var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"is-flex section-title"},[_c('h2',{staticClass:"is-marginless"},[_vm._v(_vm._s(_vm.$t("res.latest_transactions")))])]),_vm._v(" "),_c('ticker-transaction-table',{attrs:{"transactions":_vm.transactions}}),_vm._v(" "),_c('br')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23216120","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Ticker.vue
// module id = lKSd
// module chunks = 1